export function getTags(meta: any) {
    let result: string = "";
    meta?.tags.forEach((tag: any) => {
        result += tag.label;
        result = (meta.tags[meta.tags.length - 1].label !== tag.label) ? result + ', ' : result
    })
    return result;
}